import type { MergedMarketRecord } from '@/types/market';
import type { BenchmarkStats } from '@/types/insights';
import { mean, stddev } from '@/utils/numbers';

const BENCHMARK_FIELDS = [
  'medianDaysOnMarket',
  'monthsOfInventory',
  'saleToListRatioPct',
  'priceReductionSharePct',
  'medianSalePriceYoyPct',
] as const;

/**
 * Computes the statewide (or current-viewport) mean/std for every field the
 * scoring engine z-scores against. This is what makes scores relative
 * ("hotter than the rest of Texas right now") rather than absolute
 * thresholds pulled out of thin air.
 */
export function buildBenchmark(records: MergedMarketRecord[]): BenchmarkStats {
  const meanByField: Record<string, number | undefined> = {};
  const stdByField: Record<string, number | undefined> = {};

  for (const field of BENCHMARK_FIELDS) {
    const values = records
      .map((r) => r.resolved[field])
      .filter((v): v is number => typeof v === 'number');
    meanByField[field] = mean(values);
    stdByField[field] = stddev(values);
  }

  return { meanByField, stdByField, sampleSize: records.length };
}
